module.exports = __webpack_public_path__ + "img/LOGO ITALVEN.02373f82.png";